module.exports = __webpack_public_path__ + "static/media/imageA.91181cab.svg";